import { PROVENANCE_CONFIG } from "../../lib/constants.ts";
import { Tooltip } from "./Tooltip.tsx";

const PROVENANCE_DESCRIPTIONS: Record<string, string> = {
  manual: "Entered manually by your team",
  extracted: "Auto-extracted from an uploaded document",
  calculated: "Computed from other field values",
  empty: "No value set yet",
};

interface ProvenanceBadgeProps {
  sourceMethod: string | null;
  confidence?: number | null;
}

export function ProvenanceBadge({ sourceMethod, confidence }: ProvenanceBadgeProps) {
  const key = (sourceMethod || "empty") as keyof typeof PROVENANCE_CONFIG;
  const config = PROVENANCE_CONFIG[key] ?? PROVENANCE_CONFIG.empty;

  let description = PROVENANCE_DESCRIPTIONS[key] ?? "";
  if (confidence != null && key === "extracted") {
    description += ` (${Math.round(confidence * 100)}% confidence)`;
  }

  const badge = (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[12px] font-medium ${config.bg} ${config.text}`}>
      <span>{config.icon}</span>
      <span>{config.label}</span>
      {confidence != null && key === "extracted" && (
        <span className="opacity-70">· {Math.round(confidence * 100)}%</span>
      )}
    </span>
  );

  return description ? <Tooltip text={description}>{badge}</Tooltip> : badge;
}
